import React from 'react';
import PropTypes from 'prop-types';
import styles from './CustomerReviewDetail.module.css';

const RATING_VALUES = [1, 2, 3, 4, 5];

// Read-only rating display. The vector is the star exported from the KA CMS
// Seed Customer Review Figma file, and lives here rather than in the shared
// StarRating so the seed form KB-5446 already shipped keeps rendering exactly
// as it was approved.
const ReviewStars = ({ value }) => (
  <div aria-label={`${value} out of 5`} className={styles.stars} role="img">
    {RATING_VALUES.map(rating => (
      <span
        aria-hidden="true"
        className={`${styles.star} ${rating <= value ? styles.starFilled : styles.starEmpty}`}
        key={rating}
      >
        <svg fill="none" viewBox="0 0 16.7386 15.9193" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.3693 0L10.3452 6.08041L16.7386 6.08065L11.5664 9.83879L13.5418 15.9193L8.3693 12.1616L3.19679 15.9193L5.17223 9.83879L0 6.08065L6.3934 6.08041L8.3693 0Z"
            fill="currentColor"
          />
        </svg>
      </span>
    ))}
  </div>
);

ReviewStars.propTypes = {
  value: PropTypes.number,
};

ReviewStars.defaultProps = {
  value: 0,
};

export default ReviewStars;
